// extracted by mini-css-extract-plugin
export default {"card":"brands_card__gUufi","cardBody":"brands_cardBody__v3+Dt"};